import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export default function FinalCta() {
  return (
    <section id="kontakt" className="relative overflow-hidden py-16 sm:py-24 lg:py-36" data-testid="final-cta-section">
      <div className="absolute inset-0 grid-bg mask-radial opacity-60" />
      <div className="absolute left-1/2 top-1/2 h-[500px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#e01e37]/10 blur-[140px]" />

      <div className="relative mx-auto max-w-[1100px] px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="inline-flex items-center gap-3 border border-white/10 bg-white/[0.02] px-4 py-2"
        >
          <span className="h-1.5 w-1.5 bg-[#e01e37]" />
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60">
            Sprechen Sie mit uns
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto mt-8 max-w-3xl font-display text-4xl sm:text-5xl lg:text-[4rem] font-extrabold tracking-tight text-white leading-[1.02] text-balance"
        >
          Bereit, Banking in Ihr Produkt zu integrieren?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mx-auto mt-6 max-w-xl text-base lg:text-lg text-white/55 leading-relaxed"
        >
          Vereinbaren Sie eine technische Demo oder werden Sie Partner. Unser Team
          begleitet Sie von der Architektur bis zum Go-Live.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="mailto:kontakt@cashfux.com"
            data-testid="final-primary-cta"
            className="group inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-[#e01e37] px-8 py-4 text-sm font-medium text-white transition-[background-color] duration-300 hover:bg-[#c91830] accent-glow"
          >
            Plattform entdecken
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href="mailto:partner@cashfux.com"
            data-testid="final-secondary-cta"
            className="group inline-flex w-full sm:w-auto items-center justify-center gap-2 border border-white/20 px-8 py-4 text-sm font-medium text-white transition-colors duration-300 hover:bg-white/5"
          >
            Partner werden
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
